import copy from "copy-to-clipboard";
import { PalletDetail } from "../types/palletDetail";

const copyPallets = (pallets: PalletDetail[]) => {
    let palletsAsString = pallets.map(p => p.sscc).join("\n");
    copy(palletsAsString, {
        debug: false,
        message: undefined
    });
};

export { copyPallets };
